import getNetworkSpeed from "@tastetest3d/network-speed";
import { browserName, deviceType, fullBrowserVersion, osName, osVersion } from "react-device-detect";

export default async function AlertSlackOfError(errorSource, errorMessage) {
  if (window.location.href.includes("localhost")) return;

  const speed = await getNetworkSpeed({
    url: 'https://network-speed-worker.spatialcinematics.workers.dev/150'
  });

  let alertText = `
  🚨⚠ 
  Source: ${errorSource} 

  Message: ${errorMessage}
  
  Current URL: <${window.location.href}|here >

  Device Type: ${deviceType}
  Browser Name: ${browserName}
  Browser Version: ${fullBrowserVersion}
  OS Name: ${osName}
  OS Version: ${osVersion}
  Download Speed: ${speed || "-"} Mbps
  `;

  let alertObj = {
    text: alertText,
  };

  // send POST request to our slack webhook
  await fetch(process.env.REACT_APP_SLACK_ALERT_WEBHOOK, {
    mode: "no-cors",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(alertObj),
  });

  return false;
}
